// extracted by mini-css-extract-plugin
module.exports = {"atfWrap":"Jkl3h","atfIn":"F6vQ6","readmoreextend":"OxUBS","read_more":"Qd9oY"};